import { ObjectValues } from '@lumapps/lumx/react';

import { AI_REASON_TYPES } from './constants';

export enum AiFeedbackTypes {
    LIKED = 'like',
    DISLIKED = 'dislike',
}

/** Ai Detailed negative feedback possible reasons */
export type AiFeedbackReasonTypes = ObjectValues<typeof AI_REASON_TYPES>;

/** Ai positive Feedback */
export interface AiPositiveFeedback {
    type: AiFeedbackTypes.LIKED;
}

/** Ai negative detailed feedback */
export interface AiNegativeFeedback {
    type: AiFeedbackTypes.DISLIKED;
    /** The reason the feedback is negative, from a given list  */
    reason?: AiFeedbackReasonTypes;
    /** An optional comment to explain why the feedback is negative. */
    comment?: string;
}

/** AI detailed feedback  */
export type AiDetailedFeedback = AiPositiveFeedback | AiNegativeFeedback;

/**
 * Infos of the connector associated to a source used in an AI query.
 */
export interface AiSourceConnector {
    id: string;
    name: string;
    providerType: string;
}

/**
 * Object received with an AI answer when a source needs the user to Open Authorize (OAuth).
 */
export interface AiAuthorizationError {
    /** Error code */
    code: string;
    /** URI of the OAuth flow */
    connectUri: string;
    /** Connector associated to the source which has an authorization error */
    sourceConnector: AiSourceConnector;
}
